// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Insights page styling (scoped with the ins- prefix).
   Deliberately separate from insights.css, which Analytics, Data Center and
   Kanban also import for their shared header/card classes.
   Colors come from the app-wide accent tokens (.accent-blue/violet/teal/
   green/magenta/slate in App.css) plus two local ones below, so every tinted
   element works in both light and dark mode from one definition.
   ========================================================================== */

.ins-amber { --tmis-accent: #823f09; --tmis-accent-tint: #fef3c7; --tmis-accent-dark: #fbbf24; --tmis-accent-dark-text: #fbc53d; }
.ins-red   { --tmis-accent: #a11616; --tmis-accent-tint: #fee2e2; --tmis-accent-dark: #f87171; --tmis-accent-dark-text: #f8b2b2; }

.ins-page {
  --ins-muted: #475569;
  --ins-line: rgba(148, 163, 184, 0.28);
}
.dark-theme.ins-page {
  --ins-muted: rgba(255, 255, 255, 0.72);
  --ins-line: rgba(255, 255, 255, 0.12);
}
.ins-muted { color: var(--ins-muted); }

/* ---------- motion ---------- */
/* slide only: fading text in makes it momentarily fail contrast checks */
@keyframes ins-fade-up {
  from { transform: translateY(10px); }
  to   { transform: none; }
}
@keyframes ins-shimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
@keyframes ins-grow {
  from { transform: scaleX(0); }
  to   { transform: scaleX(1); }
}
.ins-fade { animation: ins-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }

@media (prefers-reduced-motion: reduce) {
  .ins-fade, .ins-bar > span, .ins-skel { animation: none !important; }
  .ins-card, .ins-hero-btn { transition: none !important; }
}

/* ---------- hero ---------- */
.ins-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 8px 0 20px;
  padding: 26px 30px;
  border-radius: 22px;
  color: #fff;
  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);
  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);
}
.dark-theme .ins-hero {
  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}
.ins-hero::before,
.ins-hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.ins-hero::before {
  width: 260px; height: 260px;
  right: -60px; top: -110px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
}
.ins-hero::after {
  width: 200px; height: 200px;
  right: 22%; bottom: -120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
}
.ins-hero-text, .ins-hero-actions { position: relative; z-index: 1; }

.ins-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  background: rgba(6, 14, 40, 0.34);
  border: 1px solid rgba(255, 255, 255, 0.28);
}
.ins-hero-title {
  margin: 10px 0 4px;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.4px;
  color: #fff;
}
.ins-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }

.ins-hero-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ins-hero-updated { font-size: 13px; font-weight: 600; color: #ffffff; }
.ins-hero .ins-hero-btn.btn {
  display: inline-flex;
  align-items: center;
  background: #fff;
  color: #1a3483;
  border: 0;
  border-radius: 999px;
  padding: 10px 20px;
  font-weight: 800;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.ins-hero .ins-hero-btn.btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 12px 22px rgba(0, 0, 0, 0.24); }
.ins-hero .ins-hero-btn.btn:disabled { opacity: 1; }

/* ---------- cards ---------- */
.ins-card {
  border: 1px solid transparent;
  border-radius: 18px !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.ins-card:hover { transform: translateY(-2px); box-shadow: 0 18px 38px rgba(15, 23, 42, 0.12); }
.dark-theme .ins-card {
  background: #212529;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}
.dark-theme .ins-card:hover { box-shadow: 0 18px 38px rgba(0, 0, 0, 0.5); }

/* ---------- stat cards ---------- */
.ins-stat { position: relative; border-top: 4px solid var(--tmis-accent); }
.dark-theme .ins-stat { border-top-color: var(--tmis-accent-dark); }
.ins-stat .card-body { position: relative; min-height: 158px; }
.ins-stat-watermark {
  position: absolute;
  right: -14px; bottom: -18px;
  font-size: 96px;
  line-height: 1;
  color: var(--tmis-accent);
  opacity: 0.1;
  pointer-events: none;
}
.dark-theme .ins-stat-watermark { color: var(--tmis-accent-dark); opacity: 0.14; }
.ins-stat-top { display: flex; align-items: center; gap: 10px; }
.ins-stat-icon,
.ins-title-icon,
.ins-tile-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .ins-stat-icon,
.dark-theme .ins-title-icon,
.dark-theme .ins-tile-icon {
  background: rgba(255, 255, 255, 0.1);
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}
.ins-stat-icon { width: 40px; height: 40px; border-radius: 12px; font-size: 20px; }
.ins-stat-title {
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--ins-muted);
}
.ins-stat-value {
  margin: 12px 0 4px;
  font-size: 34px;
  font-weight: 850;
  line-height: 1.1;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dark-theme .ins-stat-value { color: #fff; }
.ins-stat-note { position: relative; z-index: 1; font-size: 13px; color: var(--ins-muted); }

.ins-progress {
  position: relative;
  z-index: 1;
  height: 6px;
  margin-top: 12px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.25);
  overflow: hidden;
}
.ins-progress > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--tmis-accent);
  transform-origin: left;
  animation: ins-grow 0.9s ease both;
}
.dark-theme .ins-progress > span { background: var(--tmis-accent-dark); }

/* ---------- loading skeletons ---------- */
.ins-skel {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16) 25%, rgba(148, 163, 184, 0.34) 37%, rgba(148, 163, 184, 0.16) 63%);
  background-size: 400% 100%;
  animation: ins-shimmer 1.3s ease infinite;
}
.ins-skel-value { width: 96px; height: 36px; margin: 12px 0 6px; }
.ins-skel-line { height: 14px; margin: 10px 0; }

/* ---------- section titles ---------- */
.ins-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 16px;
}
.ins-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
.dark-theme .ins-section-title { color: #fff; }
.ins-title-icon { width: 34px; height: 34px; border-radius: 10px; font-size: 17px; }
.ins-count {
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .ins-count { background: rgba(255, 255, 255, 0.1); background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent); color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }

.ins-ai-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.4px;
  color: #fff;
  background: linear-gradient(120deg, #1a3483, #6d3fae);
}

/* ---------- overview ---------- */
.ins-summary {
  position: relative;
  margin: 0 0 14px;
  padding: 16px 18px 16px 22px;
  border-radius: 14px;
  font-size: 15px;
  line-height: 1.7;
  background: linear-gradient(120deg, rgba(26, 52, 131, 0.08), rgba(109, 63, 174, 0.08));
}
.ins-summary::before {
  content: "";
  position: absolute;
  left: 0; top: 10px; bottom: 10px;
  width: 4px;
  border-radius: 4px;
  background: linear-gradient(180deg, #1a3483, #6d3fae);
}
.dark-theme .ins-summary {
  background: linear-gradient(120deg, rgba(57, 135, 229, 0.14), rgba(124, 58, 237, 0.14));
}
.dark-theme .ins-summary::before { background: linear-gradient(180deg, #3987e5, #7c3aed); }

.ins-tile {
  height: 100%;
  padding: 13px 14px;
  border-radius: 14px;
  border: 1px solid var(--ins-line);
  border-left: 4px solid var(--tmis-accent);
  background: var(--tmis-accent-tint);
  background: color-mix(in srgb, var(--tmis-accent) 6%, transparent);
}
.dark-theme .ins-tile {
  border-left-color: var(--tmis-accent-dark);
  background: rgba(255, 255, 255, 0.04);
  background: color-mix(in srgb, var(--tmis-accent-dark) 10%, transparent);
}
.ins-tile-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 800;
  color: var(--tmis-accent);
}
.dark-theme .ins-tile-head { color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }
.ins-tile-icon { width: 24px; height: 24px; border-radius: 8px; font-size: 13px; }
.ins-tile-text { font-size: 14px; line-height: 1.55; }

/* ---------- avatars, pills, people ---------- */
.ins-person { display: flex; align-items: center; gap: 10px; min-width: 0; }
.ins-person-name { font-weight: 700; line-height: 1.25; }
.ins-person-sub { font-size: 12px; color: var(--ins-muted); }

.ins-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.ins-pill::before {
  content: "";
  width: 7px; height: 7px;
  border-radius: 50%;
  background: currentColor;
}
.dark-theme .ins-pill {
  background: rgba(255, 255, 255, 0.1);
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

/* source / status chips take their color from Data Center / status colors */
.ins-chip {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

/* ---------- contact-today items ---------- */
.ins-contact {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 10px;
  border-radius: 14px;
  border: 1px solid var(--ins-line);
  border-left: 4px solid #16a34a;
  background: rgba(22, 163, 74, 0.04);
  transition: background 0.15s ease;
}
.ins-contact:last-child { margin-bottom: 0; }
.ins-contact:hover { background: rgba(22, 163, 74, 0.09); }
.dark-theme .ins-contact { background: rgba(74, 222, 128, 0.05); border-left-color: #4ade80; }
.dark-theme .ins-contact:hover { background: rgba(74, 222, 128, 0.1); }
.ins-contact-body { flex: 1 1; min-width: 0; }
.ins-contact-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; }
.ins-contact-why { margin: 4px 0 8px; font-size: 13.5px; color: var(--ins-muted); }
.ins-action {
  margin-bottom: 10px;
  padding: 8px 11px;
  border-radius: 10px;
  font-size: 13.5px;
  background: rgba(26, 52, 131, 0.07);
}
.ins-action b { color: #1a3483; }
.dark-theme .ins-action { background: rgba(255, 255, 255, 0.07); }
.dark-theme .ins-action b { color: #b9d4f9; }

.ins-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border: 0;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(120deg, #1a3483, #2d52c4);
  box-shadow: 0 6px 14px rgba(26, 52, 131, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
.ins-btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 10px 18px rgba(26, 52, 131, 0.34); }
.ins-btn:disabled { opacity: 1; cursor: not-allowed; box-shadow: none; color: #334155; background: #e2e8f0; }
.dark-theme .ins-btn { background: linear-gradient(120deg, #2457b8, #5a43d0); }
.dark-theme .ins-btn:disabled { color: #d1d5db; background: #2f343a; }

/* ---------- tables ---------- */
.ins-table { margin-bottom: 0; }
.ins-table thead th {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--ins-muted);
  border-bottom-width: 2px;
  white-space: nowrap;
}
.ins-table td { vertical-align: middle; }
.ins-reason { font-size: 13.5px; }
.ins-nowrap { white-space: nowrap; }

/* Who to Watch: give names room so they stay on one line, keep the risk
   pill snug, and let the long "Why" text take whatever is left. */
.ins-watch-table .ins-person { min-width: 230px; }
.ins-watch-table th:nth-child(2),
.ins-watch-table td:nth-child(2) { width: 1%; white-space: nowrap; }

.ins-score {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px; height: 38px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 850;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
  box-shadow: inset 0 0 0 2px var(--tmis-accent);
}
.dark-theme .ins-score {
  background: rgba(255, 255, 255, 0.08);
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
  box-shadow: inset 0 0 0 2px var(--tmis-accent-dark);
}

/* ---------- countries ---------- */
.ins-countries { display: flex; flex-direction: column; gap: 14px; }
.ins-country-row { display: flex; align-items: center; gap: 12px; }
.ins-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px; height: 28px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 850;
  background: rgba(148, 163, 184, 0.2);
  color: var(--ins-muted);
}
.ins-rank.r1 { background: #f59e0b; color: #3b2300; box-shadow: 0 3px 8px rgba(245, 158, 11, 0.45); }
.ins-rank.r2 { background: #cbd5e1; color: #1e293b; }
.ins-rank.r3 { background: #d99863; color: #3a1d06; }
.ins-country-main { flex: 1 1; min-width: 0; }
.ins-country-line { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 5px; }
.ins-country-name { font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ins-country-count { font-weight: 850; }
.ins-country-count small { margin-left: 6px; font-size: 12px; font-weight: 700; color: var(--ins-muted); }
.ins-bar { height: 8px; border-radius: 999px; background: rgba(148, 163, 184, 0.22); overflow: hidden; }
.ins-bar > span {
  display: block;
  height: 100%;
  min-width: 4px;
  border-radius: inherit;
  background: linear-gradient(90deg, #1a3483, #3b82f6);
  transform-origin: left;
  animation: ins-grow 0.9s ease both;
}
.ins-country-row:first-child .ins-bar > span { background: linear-gradient(90deg, #d97706, #fbbf24); }
.dark-theme .ins-bar > span { background: linear-gradient(90deg, #3987e5, #7c3aed); }
.dark-theme .ins-country-row:first-child .ins-bar > span { background: linear-gradient(90deg, #f59e0b, #fcd34d); }

/* ---------- duplicates ---------- */
.ins-dup {
  margin-bottom: 10px;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid var(--ins-line);
  border-left: 4px solid #f59e0b;
  background: rgba(245, 158, 11, 0.06);
}
.ins-dup:last-child { margin-bottom: 0; }
.dark-theme .ins-dup { background: rgba(251, 191, 36, 0.07); border-left-color: #fbbf24; }
.ins-dup-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.ins-dup-phone {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 8px 0 4px;
  padding: 3px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  background: rgba(148, 163, 184, 0.18);
}
.ins-dup-person {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 7px;
  padding: 7px 9px;
  border-radius: 10px;
  font-size: 13px;
  background: rgba(15, 23, 42, 0.04);
}
.dark-theme .ins-dup-person { background: rgba(255, 255, 255, 0.07); }

/* ---------- empty state ---------- */
.ins-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 26px 16px;
  text-align: center;
  border-radius: 14px;
  border: 1px dashed var(--ins-line);
  color: var(--ins-muted);
}
.ins-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px; height: 42px;
  border-radius: 50%;
  font-size: 21px;
  background: rgba(148, 163, 184, 0.18);
}

@media (max-width: 768px) {
  .ins-hero { padding: 22px 20px; }
  .ins-hero-title { font-size: 26px; }
  .ins-hero-actions { width: 100%; justify-content: space-between; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/insightsPage.css"],"names":[],"mappings":"AAAA;;;;;;;+EAO+E;;AAE/E,aAAa,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACjI,aAAa,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;;AAEjI;EACE,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;AACA,aAAa,uBAAuB,EAAE;;AAEtC,iCAAiC;AACjC,yEAAyE;AACzE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,eAAe,EAAE;AAC1B;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;AACA;EACE,OAAO,oBAAoB,EAAE;EAC7B,OAAO,oBAAoB,EAAE;AAC/B;AACA,YAAY,sCAAsC,EAAE,8BAA8B,EAAE;;AAEpF;EACE,wCAAwC,0BAA0B,EAAE;EACpE,2BAA2B,2BAA2B,EAAE;AAC1D;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;AACA;EACE,0EAA0E;EAC1E,2CAA2C;AAC7C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,WAAW;EACzB,+EAA+E;AACjF;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,UAAU,EAAE,cAAc;EAC1B,+EAA+E;AACjF;AACA,oCAAoC,kBAAkB,EAAE,UAAU,EAAE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA,gBAAgB,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEhF,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACpF,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;AACzD;AACA,mDAAmD,2BAA2B,EAAE,2CAA2C,EAAE;AAC7H,uCAAuC,UAAU,EAAE;;AAEnD,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;EAC9C,gBAAgB;EAChB,uDAAuD;AACzD;AACA,kBAAkB,2BAA2B,EAAE,8CAA8C,EAAE;AAC/F;EACE,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,2CAA2C;AAC7C;AACA,8BAA8B,0CAA0C,EAAE;;AAE1E,qCAAqC;AACrC,YAAY,kBAAkB,EAAE,wCAAwC,EAAE;AAC1E,wBAAwB,yCAAyC,EAAE;AACnE,uBAAuB,kBAAkB,EAAE,iBAAiB,EAAE;AAC9D;EACE,kBAAkB;EAClB,YAAY,EAAE,aAAa;EAC3B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;AACA,kCAAkC,8BAA8B,EAAE,aAAa,EAAE;AACjF,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC/D;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;;;EAGE,oCAAoC;EACpC,wEAAwE;EACxE,4DAA4D;AAC9D;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAClF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,8BAA8B,WAAW,EAAE;AAC3C,iBAAiB,kBAAkB,EAAE,UAAU,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAE3F;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;AACA,mCAAmC,mCAAmC,EAAE;;AAExE,4CAA4C;AAC5C;EACE,cAAc;EACd,kBAAkB;EAClB,+HAA+H;EAC/H,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACjE,iBAAiB,YAAY,EAAE,cAAc,EAAE;;AAE/C,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,iCAAiC,WAAW,EAAE;AAC9C,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACnF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;AACA,yBAAyB,oCAAoC,EAAE,wEAAwE,EAAE,4DAA4D,EAAE;;AAEvM;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,qDAAqD;AACvD;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sFAAsF;AACxF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,SAAS,EAAE,YAAY;EAChC,UAAU;EACV,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,uFAAuF;AACzF;AACA,mCAAmC,qDAAqD,EAAE;;AAE1F;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,yCAAyC;EACzC,mCAAmC;EACnC,kEAAkE;AACpE;AACA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,wEAAwE;AAC1E;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,6BAA6B,4DAA4D,EAAE;AAC3F,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACjF,iBAAiB,eAAe,EAAE,iBAAiB,EAAE;;AAErD,iDAAiD;AACjD,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC3E,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;AACxD,kBAAkB,eAAe,EAAE,uBAAuB,EAAE;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,wEAAwE;EACxE,4DAA4D;AAC9D;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;EACnC,iCAAiC;AACnC;AACA,0BAA0B,gBAAgB,EAAE;AAC5C,qBAAqB,mCAAmC,EAAE;AAC1D,2BAA2B,oCAAoC,EAAE,0BAA0B,EAAE;AAC7F,iCAAiC,mCAAmC,EAAE;AACtE,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ,EAAE,eAAe,EAAE;AACnH,mBAAmB,iBAAiB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;AAClF;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;AACA,gBAAgB,cAAc,EAAE;AAChC,0BAA0B,qCAAqC,EAAE;AACjE,4BAA4B,cAAc,EAAE;;AAE5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qDAAqD;EACrD,8CAA8C;EAC9C,2EAA2E;AAC7E;AACA,gCAAgC,2BAA2B,EAAE,+CAA+C,EAAE;AAC9G,oBAAoB,UAAU,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC5G,uBAAuB,qDAAqD,EAAE;AAC9E,gCAAgC,cAAc,EAAE,mBAAmB,EAAE;;AAErE,iCAAiC;AACjC,aAAa,gBAAgB,EAAE;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;AACA,gBAAgB,sBAAsB,EAAE;AACxC,cAAc,iBAAiB,EAAE;AACjC,cAAc,mBAAmB,EAAE;;AAEnC;kEACkE;AAClE,+BAA+B,gBAAgB,EAAE;AACjD;mCACmC,SAAS,EAAE,mBAAmB,EAAE;;AAEnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,qCAAqC;EACrC,wEAAwE;EACxE,4DAA4D;EAC5D,mDAAmD;AACrD;;AAEA,oCAAoC;AACpC,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;AACzB;AACA,eAAe,mBAAmB,EAAE,cAAc,EAAE,8CAA8C,EAAE;AACpG,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,oBAAoB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzH,oBAAoB,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACtG,qBAAqB,gBAAgB,EAAE;AACvC,2BAA2B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACzG,WAAW,WAAW,EAAE,oBAAoB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AACvG;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oDAAoD;EACpD,sBAAsB;EACtB,kCAAkC;AACpC;AACA,+CAA+C,oDAAoD,EAAE;AACrG,8BAA8B,oDAAoD,EAAE;AACpF,2DAA2D,oDAAoD,EAAE;;AAEjH,qCAAqC;AACrC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;AACtC;AACA,sBAAsB,gBAAgB,EAAE;AACxC,uBAAuB,oCAAoC,EAAE,0BAA0B,EAAE;AACzF,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAC9F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;AACA,8BAA8B,qCAAqC,EAAE;;AAErE,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,YAAY,kBAAkB,EAAE;EAChC,kBAAkB,eAAe,EAAE;EACnC,oBAAoB,WAAW,EAAE,8BAA8B,EAAE;AACnE","sourcesContent":["/* ==========================================================================\n   Insights page styling (scoped with the ins- prefix).\n   Deliberately separate from insights.css, which Analytics, Data Center and\n   Kanban also import for their shared header/card classes.\n   Colors come from the app-wide accent tokens (.accent-blue/violet/teal/\n   green/magenta/slate in App.css) plus two local ones below, so every tinted\n   element works in both light and dark mode from one definition.\n   ========================================================================== */\n\n.ins-amber { --tmis-accent: #823f09; --tmis-accent-tint: #fef3c7; --tmis-accent-dark: #fbbf24; --tmis-accent-dark-text: #fbc53d; }\n.ins-red   { --tmis-accent: #a11616; --tmis-accent-tint: #fee2e2; --tmis-accent-dark: #f87171; --tmis-accent-dark-text: #f8b2b2; }\n\n.ins-page {\n  --ins-muted: #475569;\n  --ins-line: rgba(148, 163, 184, 0.28);\n}\n.dark-theme.ins-page {\n  --ins-muted: rgba(255, 255, 255, 0.72);\n  --ins-line: rgba(255, 255, 255, 0.12);\n}\n.ins-muted { color: var(--ins-muted); }\n\n/* ---------- motion ---------- */\n/* slide only: fading text in makes it momentarily fail contrast checks */\n@keyframes ins-fade-up {\n  from { transform: translateY(10px); }\n  to   { transform: none; }\n}\n@keyframes ins-shimmer {\n  0%   { background-position: 100% 0; }\n  100% { background-position: 0 0; }\n}\n@keyframes ins-grow {\n  from { transform: scaleX(0); }\n  to   { transform: scaleX(1); }\n}\n.ins-fade { animation: ins-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }\n\n@media (prefers-reduced-motion: reduce) {\n  .ins-fade, .ins-bar > span, .ins-skel { animation: none !important; }\n  .ins-card, .ins-hero-btn { transition: none !important; }\n}\n\n/* ---------- hero ---------- */\n.ins-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 8px 0 20px;\n  padding: 26px 30px;\n  border-radius: 22px;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);\n  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);\n}\n.dark-theme .ins-hero {\n  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n}\n.ins-hero::before,\n.ins-hero::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n}\n.ins-hero::before {\n  width: 260px; height: 260px;\n  right: -60px; top: -110px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);\n}\n.ins-hero::after {\n  width: 200px; height: 200px;\n  right: 22%; bottom: -120px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);\n}\n.ins-hero-text, .ins-hero-actions { position: relative; z-index: 1; }\n\n.ins-hero-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  background: rgba(6, 14, 40, 0.34);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n.ins-hero-title {\n  margin: 10px 0 4px;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n.ins-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }\n\n.ins-hero-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n.ins-hero-updated { font-size: 13px; font-weight: 600; color: #ffffff; }\n.ins-hero .ins-hero-btn.btn {\n  display: inline-flex;\n  align-items: center;\n  background: #fff;\n  color: #1a3483;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 20px;\n  font-weight: 800;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.ins-hero .ins-hero-btn.btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 12px 22px rgba(0, 0, 0, 0.24); }\n.ins-hero .ins-hero-btn.btn:disabled { opacity: 1; }\n\n/* ---------- cards ---------- */\n.ins-card {\n  border: 1px solid transparent;\n  border-radius: 18px !important;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);\n  overflow: hidden;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n.ins-card:hover { transform: translateY(-2px); box-shadow: 0 18px 38px rgba(15, 23, 42, 0.12); }\n.dark-theme .ins-card {\n  background: #212529;\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n.dark-theme .ins-card:hover { box-shadow: 0 18px 38px rgba(0, 0, 0, 0.5); }\n\n/* ---------- stat cards ---------- */\n.ins-stat { position: relative; border-top: 4px solid var(--tmis-accent); }\n.dark-theme .ins-stat { border-top-color: var(--tmis-accent-dark); }\n.ins-stat .card-body { position: relative; min-height: 158px; }\n.ins-stat-watermark {\n  position: absolute;\n  right: -14px; bottom: -18px;\n  font-size: 96px;\n  line-height: 1;\n  color: var(--tmis-accent);\n  opacity: 0.1;\n  pointer-events: none;\n}\n.dark-theme .ins-stat-watermark { color: var(--tmis-accent-dark); opacity: 0.14; }\n.ins-stat-top { display: flex; align-items: center; gap: 10px; }\n.ins-stat-icon,\n.ins-title-icon,\n.ins-tile-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .ins-stat-icon,\n.dark-theme .ins-title-icon,\n.dark-theme .ins-tile-icon {\n  background: rgba(255, 255, 255, 0.1);\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n.ins-stat-icon { width: 40px; height: 40px; border-radius: 12px; font-size: 20px; }\n.ins-stat-title {\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--ins-muted);\n}\n.ins-stat-value {\n  margin: 12px 0 4px;\n  font-size: 34px;\n  font-weight: 850;\n  line-height: 1.1;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dark-theme .ins-stat-value { color: #fff; }\n.ins-stat-note { position: relative; z-index: 1; font-size: 13px; color: var(--ins-muted); }\n\n.ins-progress {\n  position: relative;\n  z-index: 1;\n  height: 6px;\n  margin-top: 12px;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.25);\n  overflow: hidden;\n}\n.ins-progress > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--tmis-accent);\n  transform-origin: left;\n  animation: ins-grow 0.9s ease both;\n}\n.dark-theme .ins-progress > span { background: var(--tmis-accent-dark); }\n\n/* ---------- loading skeletons ---------- */\n.ins-skel {\n  display: block;\n  border-radius: 8px;\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16) 25%, rgba(148, 163, 184, 0.34) 37%, rgba(148, 163, 184, 0.16) 63%);\n  background-size: 400% 100%;\n  animation: ins-shimmer 1.3s ease infinite;\n}\n.ins-skel-value { width: 96px; height: 36px; margin: 12px 0 6px; }\n.ins-skel-line { height: 14px; margin: 10px 0; }\n\n/* ---------- section titles ---------- */\n.ins-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.ins-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n}\n.dark-theme .ins-section-title { color: #fff; }\n.ins-title-icon { width: 34px; height: 34px; border-radius: 10px; font-size: 17px; }\n.ins-count {\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .ins-count { background: rgba(255, 255, 255, 0.1); background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent); color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }\n\n.ins-ai-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 11px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483, #6d3fae);\n}\n\n/* ---------- overview ---------- */\n.ins-summary {\n  position: relative;\n  margin: 0 0 14px;\n  padding: 16px 18px 16px 22px;\n  border-radius: 14px;\n  font-size: 15px;\n  line-height: 1.7;\n  background: linear-gradient(120deg, rgba(26, 52, 131, 0.08), rgba(109, 63, 174, 0.08));\n}\n.ins-summary::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 10px; bottom: 10px;\n  width: 4px;\n  border-radius: 4px;\n  background: linear-gradient(180deg, #1a3483, #6d3fae);\n}\n.dark-theme .ins-summary {\n  background: linear-gradient(120deg, rgba(57, 135, 229, 0.14), rgba(124, 58, 237, 0.14));\n}\n.dark-theme .ins-summary::before { background: linear-gradient(180deg, #3987e5, #7c3aed); }\n\n.ins-tile {\n  height: 100%;\n  padding: 13px 14px;\n  border-radius: 14px;\n  border: 1px solid var(--ins-line);\n  border-left: 4px solid var(--tmis-accent);\n  background: var(--tmis-accent-tint);\n  background: color-mix(in srgb, var(--tmis-accent) 6%, transparent);\n}\n.dark-theme .ins-tile {\n  border-left-color: var(--tmis-accent-dark);\n  background: rgba(255, 255, 255, 0.04);\n  background: color-mix(in srgb, var(--tmis-accent-dark) 10%, transparent);\n}\n.ins-tile-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--tmis-accent);\n}\n.dark-theme .ins-tile-head { color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }\n.ins-tile-icon { width: 24px; height: 24px; border-radius: 8px; font-size: 13px; }\n.ins-tile-text { font-size: 14px; line-height: 1.55; }\n\n/* ---------- avatars, pills, people ---------- */\n.ins-person { display: flex; align-items: center; gap: 10px; min-width: 0; }\n.ins-person-name { font-weight: 700; line-height: 1.25; }\n.ins-person-sub { font-size: 12px; color: var(--ins-muted); }\n\n.ins-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 11px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.ins-pill::before {\n  content: \"\";\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.dark-theme .ins-pill {\n  background: rgba(255, 255, 255, 0.1);\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n/* source / status chips take their color from Data Center / status colors */\n.ins-chip {\n  display: inline-block;\n  padding: 3px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n/* ---------- contact-today items ---------- */\n.ins-contact {\n  display: flex;\n  gap: 12px;\n  padding: 14px;\n  margin-bottom: 10px;\n  border-radius: 14px;\n  border: 1px solid var(--ins-line);\n  border-left: 4px solid #16a34a;\n  background: rgba(22, 163, 74, 0.04);\n  transition: background 0.15s ease;\n}\n.ins-contact:last-child { margin-bottom: 0; }\n.ins-contact:hover { background: rgba(22, 163, 74, 0.09); }\n.dark-theme .ins-contact { background: rgba(74, 222, 128, 0.05); border-left-color: #4ade80; }\n.dark-theme .ins-contact:hover { background: rgba(74, 222, 128, 0.1); }\n.ins-contact-body { flex: 1; min-width: 0; }\n.ins-contact-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; }\n.ins-contact-why { margin: 4px 0 8px; font-size: 13.5px; color: var(--ins-muted); }\n.ins-action {\n  margin-bottom: 10px;\n  padding: 8px 11px;\n  border-radius: 10px;\n  font-size: 13.5px;\n  background: rgba(26, 52, 131, 0.07);\n}\n.ins-action b { color: #1a3483; }\n.dark-theme .ins-action { background: rgba(255, 255, 255, 0.07); }\n.dark-theme .ins-action b { color: #b9d4f9; }\n\n.ins-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  border: 0;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 800;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483, #2d52c4);\n  box-shadow: 0 6px 14px rgba(26, 52, 131, 0.28);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n}\n.ins-btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 10px 18px rgba(26, 52, 131, 0.34); }\n.ins-btn:disabled { opacity: 1; cursor: not-allowed; box-shadow: none; color: #334155; background: #e2e8f0; }\n.dark-theme .ins-btn { background: linear-gradient(120deg, #2457b8, #5a43d0); }\n.dark-theme .ins-btn:disabled { color: #d1d5db; background: #2f343a; }\n\n/* ---------- tables ---------- */\n.ins-table { margin-bottom: 0; }\n.ins-table thead th {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--ins-muted);\n  border-bottom-width: 2px;\n  white-space: nowrap;\n}\n.ins-table td { vertical-align: middle; }\n.ins-reason { font-size: 13.5px; }\n.ins-nowrap { white-space: nowrap; }\n\n/* Who to Watch: give names room so they stay on one line, keep the risk\n   pill snug, and let the long \"Why\" text take whatever is left. */\n.ins-watch-table .ins-person { min-width: 230px; }\n.ins-watch-table th:nth-child(2),\n.ins-watch-table td:nth-child(2) { width: 1%; white-space: nowrap; }\n\n.ins-score {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px; height: 38px;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 850;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n  box-shadow: inset 0 0 0 2px var(--tmis-accent);\n}\n.dark-theme .ins-score {\n  background: rgba(255, 255, 255, 0.08);\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n  box-shadow: inset 0 0 0 2px var(--tmis-accent-dark);\n}\n\n/* ---------- countries ---------- */\n.ins-countries { display: flex; flex-direction: column; gap: 14px; }\n.ins-country-row { display: flex; align-items: center; gap: 12px; }\n.ins-rank {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 850;\n  background: rgba(148, 163, 184, 0.2);\n  color: var(--ins-muted);\n}\n.ins-rank.r1 { background: #f59e0b; color: #3b2300; box-shadow: 0 3px 8px rgba(245, 158, 11, 0.45); }\n.ins-rank.r2 { background: #cbd5e1; color: #1e293b; }\n.ins-rank.r3 { background: #d99863; color: #3a1d06; }\n.ins-country-main { flex: 1; min-width: 0; }\n.ins-country-line { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 5px; }\n.ins-country-name { font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ins-country-count { font-weight: 850; }\n.ins-country-count small { margin-left: 6px; font-size: 12px; font-weight: 700; color: var(--ins-muted); }\n.ins-bar { height: 8px; border-radius: 999px; background: rgba(148, 163, 184, 0.22); overflow: hidden; }\n.ins-bar > span {\n  display: block;\n  height: 100%;\n  min-width: 4px;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #1a3483, #3b82f6);\n  transform-origin: left;\n  animation: ins-grow 0.9s ease both;\n}\n.ins-country-row:first-child .ins-bar > span { background: linear-gradient(90deg, #d97706, #fbbf24); }\n.dark-theme .ins-bar > span { background: linear-gradient(90deg, #3987e5, #7c3aed); }\n.dark-theme .ins-country-row:first-child .ins-bar > span { background: linear-gradient(90deg, #f59e0b, #fcd34d); }\n\n/* ---------- duplicates ---------- */\n.ins-dup {\n  margin-bottom: 10px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  border: 1px solid var(--ins-line);\n  border-left: 4px solid #f59e0b;\n  background: rgba(245, 158, 11, 0.06);\n}\n.ins-dup:last-child { margin-bottom: 0; }\n.dark-theme .ins-dup { background: rgba(251, 191, 36, 0.07); border-left-color: #fbbf24; }\n.ins-dup-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }\n.ins-dup-phone {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 8px 0 4px;\n  padding: 3px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  background: rgba(148, 163, 184, 0.18);\n}\n.ins-dup-person {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin-top: 7px;\n  padding: 7px 9px;\n  border-radius: 10px;\n  font-size: 13px;\n  background: rgba(15, 23, 42, 0.04);\n}\n.dark-theme .ins-dup-person { background: rgba(255, 255, 255, 0.07); }\n\n/* ---------- empty state ---------- */\n.ins-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 26px 16px;\n  text-align: center;\n  border-radius: 14px;\n  border: 1px dashed var(--ins-line);\n  color: var(--ins-muted);\n}\n.ins-empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px; height: 42px;\n  border-radius: 50%;\n  font-size: 21px;\n  background: rgba(148, 163, 184, 0.18);\n}\n\n@media (max-width: 768px) {\n  .ins-hero { padding: 22px 20px; }\n  .ins-hero-title { font-size: 26px; }\n  .ins-hero-actions { width: 100%; justify-content: space-between; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
